import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Oficina} from "../../_model/";
import {config} from "../../../../environments/config";
import {AuthenticationService} from 'app/auth/service';
import {AlertService} from '../alert/alert.service';
import {User} from 'app/auth/models';

@Injectable({
    providedIn: 'root'
})
export class OficinaService {
    public currentUser: User;

    constructor(private http: HttpClient,
                private _authenticationService: AuthenticationService,
                private alertService: AlertService,) {
        this._authenticationService.currentUser.subscribe(x => (this.currentUser = x));
    }

    getAll() {
        return this.http.get<Oficina[]>(`${config.apiUrl}/oficina/get`);
    }

    getOficina(codigo: number) {
        const params = new HttpParams()
            .set('token', this.currentUser.list)
            .set('codigo', codigo.toString());
        return this.http.post<any>(`${config.apiUrl}/oficina/getoficina`, params)
            .toPromise()
            .then((res) => <Oficina>res.data)
            .then((data) => {
                return data;
            });
    }
}
